import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { toggleIframe } from 'store/app/app.actions';

import Header from 'components/Header';
import Footer from 'components/Footer';
import Nav from './Nav';

import RootState from 'store/state';
import classNames from 'classnames';

import './menu.scss';
import { isNil } from 'utils';

interface Props extends ReturnType<typeof mapStateToProps> {
    toggleIframe: () => void;
}

class Menu extends PureComponent<Props> {
    shouldShowCCPIcon<T>(valueInAppConfig : T, valueInAdminSettings : T ) : T | boolean {
        if (!isNil(valueInAdminSettings)) {
            return valueInAdminSettings
        }

        if (!isNil(valueInAppConfig)) {
            return !valueInAppConfig
        }

        return true
    }

    render() {
        const { disableCCP, showCCPIcon } = this.props;
        
        return (
            <section
                className={classNames({
                    menu: true,
                    'after-call': this.props.afterCallWork,
                })}
            >
                <Header logoURL={this.props.logoURL} name={this.props.name} />
                <Nav />
                {this.shouldShowCCPIcon(disableCCP, showCCPIcon) && <Footer onClick={this.props.toggleIframe} />}
            </section>
        );
    }
}

function mapStateToProps(state: RootState) {
    return {
        name: state.app.name,
        logoURL: state.app.logoURL,
        afterCallWork: state.user.status.name === 'AfterCallWork' || false,
        disableCCP: state.app.appConfig.disableCCP,
        allowAudioSettings: state.app.appConfig.allowAudioSettings,
        showCCPIcon: state.settings.settings?.appConfigurations?.allowCCPWindow
    };
}

export default connect(mapStateToProps, { toggleIframe })(Menu);
